//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    IMPORT_ACCOUNT_SEARCH_ACCOUNTS_REQUEST,
    IMPORT_ACCOUNT_GET_STATUS_REQUEST,
    IMPORT_ACCOUNT_IMPORT_REQUEST,
    IMPORT_ACCOUNT_GET_ACCOUNT_BY_PX_REQUEST,
    IMPORT_ACCOUNT_GET_MIGRATION_ACCOUNT_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    accountsImportSearchAccountResult,
    importAccountGetAccountByPxResult,
    importAccountGetStatusResult,
    importAccountResult,
    importAccountGetMigrationAccountResult,
} from 'Redux/actions';


function* searchExternalCompanies({ payload }) {
    const { openSearch, sourcePlatform } = payload
    try {
        let QUERY = `
            query searchExternalCompanies ($sourcePlatform: enumPlatform!, $openSearch: String!, $offset: Int!, $limit: Int!) {
                result: searchExternalCompanies (sourcePlatform: $sourcePlatform, openSearch: $openSearch, offset: $offset, limit: $limit) {
                    items
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                sourcePlatform,
                openSearch,
                limit: 1000,
                offset: (sourcePlatform === 'TSO') ? 1 : 0,
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result
            let accounts = items ? JSON.parse(items) : []
            yield put(accountsImportSearchAccountResult(accounts))
        }
        else {
            yield put(accountsImportSearchAccountResult([]))
        }

    } catch (exc) {
        yield put(accountsImportSearchAccountResult([]))
        ExceptionManager(exc, 'Modules/importAccount/views/components/importAccounts/redux/saga', 'searchAccount');
    }
}

function* getCompanyMigrationStatus({ payload }) {
    const { externalCompanyId, sourcePlatform } = payload
    try {
        let QUERY = `
            query getCompanyMigrationStatus ($externalCompanyId: Int!, $sourcePlatform: enumPlatform!) {
                result: getCompanyMigrationStatus (externalCompanyId: $externalCompanyId, sourcePlatform: $sourcePlatform)
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                externalCompanyId,
                sourcePlatform,
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(importAccountGetStatusResult(data?.result))

    } catch (error) {
        yield put(importAccountGetStatusResult(null))
    }
}

function* importRecords({ payload }) {
    try {
        let QUERY = `
            mutation importRecords ($sourcePlatform: enumPlatform!, $externalCompanyId: String!, $pairWithCompanyId: Int, $entities: [enumImportEntity], $mode: enumImportMode) {
                result: importRecords (sourcePlatform: $sourcePlatform, externalCompanyId: $externalCompanyId, pairWithCompanyId: $pairWithCompanyId, entities: $entities, mode: $mode) {
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(importAccountResult(data?.result))
        } else {
            yield put(importAccountResult({ error: true }))
        }

    } catch (exc) {
        yield put(importAccountResult({ error: exc }))
        ExceptionManager(exc, 'Modules/importAccount/views/components/importAccounts/redux/saga', 'importRecords');
    }
}

function* getCompanyByPx({ payload }) {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                "conditions": {
                    "fields": [
                        "name"
                    ],
                    "terms": [payload],
                    "exact": true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result
            yield put(importAccountGetAccountByPxResult(items[0]))
        }

    } catch (exc) {
        yield put(importAccountGetAccountByPxResult(null))
        ExceptionManager(exc, 'Modules/importAccount/views/components/importAccounts/redux/saga', 'getCompanyByPx');
    }
}

export const getGtcAccounts = async (input = '') => {
    try {
        let result = []
        let QUERY = `
        query searchZonarCompanies ($name: String!, $page: Int, $limit: Int) {
            result: searchZonarCompanies (name: $name, page: $page, limit: $limit)
        }`
        result = await clientQuery(QUERY, {
            name: input,
            page: 1,
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);

        if (result?.result) {
            result = JSON.parse(result?.result)
        } else {
            result = []
        }

        return result
    } catch (exc) {
        ExceptionManager(exc, 'Modules/importAccount/views/main/.components/newMigration/redux/saga', 'getGtcAccounts');
    }
}


function* searchMigrationAccount({ payload }) {
    const { externalCompanyId, sourceEntityName, sourceName } = payload

    let conditions = [
        {
            fields: ["sourceEntityId"],
            terms: [externalCompanyId],
            exact: true
        },
        {
            fields: ["sourceEntityName"],
            terms: [sourceEntityName],
            exact: false
        },
        {
            fields: ["sourceName"],
            terms: [sourceName],
            exact: false
        }
    ]
    try {
        let QUERY = `
            query searchCompanyMigrations($conditions: [CompanyMigrationSearchInput], $sort: [CompanyMigrationSortInput], $limit: Int, $offset: Int) {
                result: searchCompanyMigrations(conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        targetAccountId
                        entities
                        mode
                    }
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions,
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );
        let result = {
            migrationAccount: null, internalMigratedAccount: null, legacyAccountCodes: null
        }
        if (data?.result && data.result.items.length > 0) {
            const migrationAccount = data.result.items[0];
            //is necessary to get the details of the internal migrated account
            let QUERY_ACCOUNT = `
                query getCompany ($id: Int!) {
                    result: getCompany (id: $id) {
                        id
                        name
                    }
                }
            `;

            let accountData = yield call(
                clientQuery,
                QUERY_ACCOUNT,
                {
                    id: migrationAccount.targetAccountId
                },
                endpoints.GRAPHQL_GENERAL,
            );

            result.migrationAccount = migrationAccount;
            result.internalMigratedAccount = accountData?.result;

        }

        //search for legacy access codes
        let queryLegacyCodes = `
                query searchZonarCompanieLegacyAccountCodes ($companyId: String!, $page: Int, $limit: Int) {
                    result: searchZonarCompanieLegacyAccountCodes (companyId: $companyId, page: $page, limit: $limit)
                }
            `
        let legacyCodesData = yield call(
            clientQuery,
            queryLegacyCodes,
            {
                companyId: externalCompanyId,
                page: 1,
                limit: 100
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (legacyCodesData?.result) {
            result.legacyAccountCodes = JSON.parse(legacyCodesData.result)
        } else {
            result.legacyAccountCodes = []
        }

        yield put(importAccountGetMigrationAccountResult(result))

    } catch (error) {
        yield put(importAccountGetMigrationAccountResult(null))
        ExceptionManager(error, 'Modules/importAccount/views/main/.components/newMigration/redux/saga', 'searchMigrationAccount');
    }
}

function* watchCatalogRequests() {
    yield takeEvery(IMPORT_ACCOUNT_SEARCH_ACCOUNTS_REQUEST, searchExternalCompanies);
    yield takeEvery(IMPORT_ACCOUNT_GET_STATUS_REQUEST, getCompanyMigrationStatus);
    yield takeEvery(IMPORT_ACCOUNT_IMPORT_REQUEST, importRecords);
    yield takeEvery(IMPORT_ACCOUNT_GET_ACCOUNT_BY_PX_REQUEST, getCompanyByPx);
    yield takeEvery(IMPORT_ACCOUNT_GET_MIGRATION_ACCOUNT_REQUEST, searchMigrationAccount);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}